import React, {Component} from 'react';
import PropTypes from 'prop-types';
import QAGroup from '../QAGroup';
import classNames from 'classnames';

class QAWorkPanel extends Component {


	state = {
		selectedItemIndex: 0,
		selectedItem: this.props.QAs ? this.props.QAs[0] : null
	};

	handleContextOnClick(event, index, QAGroup) {
		event.preventDefault();
		this.setState({
			selectedItemIndex: index,
			selectedItem: QAGroup
		})
	}


	componentDidUpdate(prevProps, prevState, snapshot) {
		if(this.props.QAs !== prevProps.QAs){
			this.setState({
				selectedItemIndex: 0,
				selectedItem: this.props.QAs ? this.props.QAs[0] : null
			})
		}
	}

	render() {
		if(this.props.QAs){
			const {QAs, className} = this.props;
			const workPanelCls = classNames("questions-area", className);
			return (
				<div className={workPanelCls}>
					<div className={"questions-area-menu"}>
						<ul>
							{
								QAs.map((item, index) => {
									return (
										<li key={index}>
											<a href="#" onClick={(e) => this.handleContextOnClick(e, index, item)}
											   className={this.state.selectedItemIndex === index ? 'active' : ''}>Question #{index + 1}</a>
										</li>
									)
								})
							}
						</ul>
					</div>
					<div className={"questions-area-content"}>
						<QAGroup QA={this.state.selectedItem} key={this.state.selectedItemIndex}/>
					</div>
				</div>
			);
		}
		else{
			return (
				<div>Empty</div>
			)
		}
	}
}


QAWorkPanel.propTypes = {
	QAs: PropTypes.array.isRequired,
};

export default QAWorkPanel;
